module.exports = __webpack_public_path__ + "img/step11.ca64ed15.png";